var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({ 'color': _vm.textColor,
    'font-size': (_vm.fontSize + "px"),
    'font-family': _vm.config.FontContent, 
    'text-transform': _vm.content.Style.ToUpperCase ? 'uppercase' : 'none' ,
    'text-align': _vm.content.Style.TextAlign,
    'padding': _vm.isDesktop ? '15px 30px' : '10px 15px' 
  })},[_vm._v(" "+_vm._s(_vm.title)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }